module.exports = __webpack_public_path__ + "img/06.bfbfaba1.jpg";